export function resolveShellRoute(pathname) {
  if (!pathname) return null;

  let normalizedPath = pathname;
  try {
    if (pathname.startsWith("http://") || pathname.startsWith("https://")) {
      normalizedPath = new URL(pathname).pathname;
    } else {
      normalizedPath = pathname.split("?")[0].split("#")[0];
    }
  } catch {
    normalizedPath = pathname.split("?")[0].split("#")[0];
  }

  const officialMatch = normalizedPath.match(/^\/matches\/official\/([^/]+)$/);
  if (officialMatch) {
    return {
      type: "official_match",
      officialId: decodeURIComponent(officialMatch[1]),
      fallbackPath: "/",
    };
  }

  return null;
}
